import React from "react";
import { plansData } from "../../data/plansData";
import whiteTick from "../../assets/whiteTick.png";

import "./Plans.css";

function Plans() {
  return (
    <div className="plans-container" id="plans">
      <div className="blur plans-blur-1"></div>
      <div className="blur plans-blur-2"></div>
      <div className="plans-header">
        <span className="stoke-text">Conheça </span>
        <span>os Planos</span>
        <span className="stoke-text">disponíveis</span>
      </div>

      <div className="plans">
        {plansData.map((plan, i) => (
          <div className="plan" key={i}>
            {plan.icon}
            <span>{plan.name}</span>
            <span>R${plan.price}</span>
            <div className="features">
              {plan.features.map((feature, i) => (
                <div className="feature">
                  <img src={whiteTick} alt="" />
                  <span key={i}>{feature}</span>
                </div>
              ))}
            </div>

            <button className="btn">
              <a
                style={{ textDecoration: "none", color: "black" }}
                href="#join"
              >
                Comece agora
              </a>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Plans;
